export const startOfDay = (value) => {
  const date = new Date(value);
  date.setHours(0, 0, 0, 0);
  return date;
};

export const getDateTimeLabel = (value) => {
  const date = new Date(value);

  return {
    dateLabel: date.toLocaleDateString(undefined, {
      weekday: "short",
      day: "2-digit",
      month: "short",
      year: "numeric",
    }),
    timeLabel:
      date.getHours() !== 0 || date.getMinutes() !== 0
        ? date.toLocaleTimeString([], {
            hour: "2-digit",
            minute: "2-digit",
          })
        : null,
  };
};

export const getRelativeDayLabel = (value) => {
  const eventDate = startOfDay(value);
  const today = startOfDay(new Date());
  const diffDays = Math.round((eventDate - today) / (1000 * 60 * 60 * 24));

  if (diffDays === 0) return "Today";
  if (diffDays === 1) return "Tomorrow";
  if (diffDays === -1) return "Yesterday";
  if (diffDays > 1) return `${diffDays} days remaining`;
  return `${Math.abs(diffDays)} days ago`;
};
